import './snyderevents/style';
import FormStructure from './snyderevents/form_structure';

export default FormStructure;